const keys = {
  gadventures: "gadventures",
  viator: "viator",
};

const partnerActivityProviders = {
  [keys.gadventures]: {
    id: keys.gadventures,
    name: "G Adventures",
  },
  [keys.viator]: {
    id: keys.viator,
    name: "Viator",
  },
};

export default partnerActivityProviders;



// WEBPACK FOOTER //
// ../server/lib/open-planet/partnerActivityProviders.js